import Cookie from "./Cookie";

export function isUser() {
  	var auth_token = Cookie.get("X-Reycreo-Auth-Token");
	var user_id= Cookie.get("X-Reycreo-Id");
  	if (auth_token && user_id) {
        return true;
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/util/CheckUser.js